import { createAction, props } from "@ngrx/store";
import { ICatalogoAppartenenzaResoResponse, ICatalogoAppartenenzaResponse, IProdottiResoResponse, IProductsBoxAcceptance } from "../../interfaces/catalogo-appartenenza";
import { IPayloadApprovvigionamentoOrdine, IPayloadApprovvigionamentoOrdineFinale, IResponseApprovvigionamentoOrdine, IResponseApprovvigionamentoOrdineFinale, IResponseApprovvigionamentoProdotti } from "../../interfaces/approvvigionamento-ordine";
import { IdReturnsActionDropdownEnum } from "../../enums/consumable-warehouse.enum";
import { IPayloadGenerateBarcodeReso, IResponseGenerateBarcodeReso } from "../../interfaces/generate-barcode-scatola-reso";
import { IResponseCreaReso } from "../../interfaces/crea-reso";
import { IPayloadStoricoOrdiniMateriali, IResponseStoricoOrdiniMateriali } from "../../interfaces/storico-ordini-materiali";

export const CATALOGO_APPARTENENZA = createAction(
  '[CONSUMABLE-WAREHOUSE] - catalogo appartenenza'
);

export const CATALOGO_APPARTENENZA_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - catalogo appartenenza success',
  props<{ responseCatalogoAppartenenza: ICatalogoAppartenenzaResponse | null }>()
);

export const APPROVVIGIONAMENTO_ORDINE = createAction(
  '[CONSUMABLE-WAREHOUSE] - retrieve approvvigionamento ordine',
  props<{ payload: IPayloadApprovvigionamentoOrdine }>()
);

export const APPROVVIGIONAMENTO_ORDINE_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - retrieve approvvigionamento ordine success',
  props<{ responseApprovvigionamentoOrdine: IResponseApprovvigionamentoOrdine | null }>()
);

export const APPROVVIGIONAMENTO_PRODOTTI = createAction(
  '[CONSUMABLE-WAREHOUSE] - retrieve approvvigionamento prodotti',
  props<{ payload: IPayloadApprovvigionamentoOrdine }>()
);

export const APPROVVIGIONAMENTO_PRODOTTI_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - retrieve approvvigionamento prodotti success',
  props<{ responseApprovvigionamentoProdotti: IResponseApprovvigionamentoProdotti | null }>()
);

export const APPROVVIGIONAMENTO_ORDINE_FINALE = createAction(
  '[CONSUMABLE-WAREHOUSE] - retrieve approvvigionamento ordine finale',
  props<{ payload: IPayloadApprovvigionamentoOrdineFinale }>()
);

export const APPROVVIGIONAMENTO_ORDINE_FINALE_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - retrieve approvvigionamento ordine finale success',
  props<{ responseApprovvigionamentoOrdineFinale: IResponseApprovvigionamentoOrdineFinale | null }>()
);

export const CATALOGO_APPARTENENZA_RESO = createAction(
  '[CONSUMABLE-WAREHOUSE] - catalogo appartenenza reso'
);

export const CATALOGO_APPARTENENZA_RESO_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - catalogo appartenenza reso success',
  props<{ responseCatalogoAppartenenzaReso: ICatalogoAppartenenzaResoResponse | null }>()
);

export const PRODOTTI_RESO = createAction(
  '[CONSUMABLE-WAREHOUSE] - prodotti reso',
  props<{ returnType: IdReturnsActionDropdownEnum }>()
);

export const PRODOTTI_RESO_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - prodotti reso success',
  props<{ responseProdottiReso: IProdottiResoResponse | null }>()
);

export const GENERTE_BARCODE_SCATOLA_RESO = createAction(
  '[CONSUMABLE-WAREHOUSE] - generate barcode scatola reso',
  props<{ payload: IPayloadGenerateBarcodeReso }>()
);

export const GENERTE_BARCODE_SCATOLA_RESO_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - generate barcode scatola reso success',
  props<{ responseGenerateBarcodeScatolaReso: IResponseGenerateBarcodeReso | null }>()
);

export const CREA_RESO = createAction(
  '[CONSUMABLE-WAREHOUSE] - crea reso',
  props<{ payload: IPayloadGenerateBarcodeReso }>()
);

export const CREA_RESO_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - crea reso success',
  props<{ responseCreaReso: IResponseCreaReso | null }>()
);

export const STORICO_ORDINI_MATERIALI = createAction(
  '[CONSUMABLE-WAREHOUSE] - storico ordini materiali',
  props<{ payload: IPayloadStoricoOrdiniMateriali }>()
);

export const STORICO_ORDINI_MATERIALI_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - storico ordini materiali success',
  props<{ responseStoricoOrdiniMateriali: IResponseStoricoOrdiniMateriali | null }>()
);

export const ESPORTA_STORICO_ORDINI = createAction(
  '[CONSUMABLE-WAREHOUSE] - esporta storico ordini',
  props<{ payload: IPayloadStoricoOrdiniMateriali }>()
);

export const ESPORTA_STORICO_ORDINI_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - esporta storico ordini success',
  props<{ responseEsportaStoricoOrdini: any }>()
);

export const MAIL_STORICO_ORDINI = createAction(
  '[CONSUMABLE-WAREHOUSE] - mail storico ordini',
  props<{ payload: IPayloadStoricoOrdiniMateriali }>()
);

export const MAIL_STORICO_ORDINI_SUCCESS = createAction(
  '[CONSUMABLE-WAREHOUSE] - mail storico ordini success',
  props<{ responseMailStoricoOrdini: IResponseStoricoOrdiniMateriali | null }>()
);

export const RETRIEVE_PRODUCTS_BOX_ACCEPTANCE = createAction(
  '[CLIENT-ACTIVITIES] - retrieve products box acceptance',
);

export const RETRIEVE_PRODUCTS_BOX_ACCEPTANCE_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve products box acceptance success',
  props<{ responseProductsBoxAcceptance: IProductsBoxAcceptance | null }>()
);


